import { createTheme } from '@mui/material/styles';

const makeTheme = (primary, secondary) =>
  createTheme({
    palette: {
      primary:    { main: primary },
      secondary:  { main: secondary },
      background: { default: '#f5f5f5' },
    },
    typography: {
      fontFamily:
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
    },
    shape: { borderRadius: 8 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { minHeight: 44, textTransform: 'none', fontWeight: 600, borderRadius: 8 },
          sizeSmall: { minHeight: 36 },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: { input: { fontSize: 16 } }, // prevents iOS auto-zoom
      },
      MuiSelect: {
        styleOverrides: { select: { fontSize: 16 } },
      },
      MuiInputLabel: {
        styleOverrides: { root: { fontSize: 15 } },
      },
      MuiTab: {
        styleOverrides: {
          root: { textTransform: 'none', fontWeight: 500, minHeight: 48, fontSize: '0.875rem' },
        },
      },
      MuiBottomNavigationAction: {
        styleOverrides: {
          root: { minWidth: 48, padding: '6px 0' },
          label: { fontSize: '0.6rem', '&.Mui-selected': { fontSize: '0.65rem' } },
        },
      },
      MuiDialog: {
        defaultProps: { fullWidth: true },
        styleOverrides: { paper: { margin: 16, maxHeight: 'calc(100% - 32px)' } },
      },
      MuiCard: {
        styleOverrides: { root: { borderRadius: 10 } },
      },
      MuiAlert: {
        styleOverrides: { root: { borderRadius: 8 } },
      },
    },
  });

export const GROUP_THEMES = {
  Dolfijnen:     makeTheme('#667eea', '#764ba2'),
  Zeeverkenners: makeTheme('#1a6baa', '#0d3d70'),
  Wildevaart:    makeTheme('#0f9b82', '#076552'),
};

export const DEFAULT_THEME = GROUP_THEMES.Dolfijnen;
